import styled from 'styled-components'
import {
  LoadingContainer,
  LoadingText,
  Spinner,
} from '../Spinners/LoginLoading.styles'

const OverlayRoot = styled(LoadingContainer)`
  position: absolute;
  inset: 0;
  z-index: 5;
  min-height: 16rem;
  border-radius: 12px;
  background:
    radial-gradient(ellipse 80% 60% at 50% -10%, rgba(62, 207, 142, 0.14), transparent 55%),
    ${({ theme }) => theme?.colors?.main || '#f1f5f9'};
`

const Title = styled.p`
  margin: 0 0 0.35rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: ${({ theme }) => theme?.colors?.textPrimary || '#21262D'};
  text-align: center;
`

const GeneratingPensionOverlay = ({
  title = 'Estamos preparando tu monto estimado…',
  subtitle = 'Solo unos segundos.',
}) => (
  <OverlayRoot role="status" aria-live="polite">
    <Spinner />
    <Title>{title}</Title>
    <LoadingText>{subtitle}</LoadingText>
  </OverlayRoot>
)

export default GeneratingPensionOverlay
